export type HydrateOn = 'idle' | 'scroll';

export type HydrationSchedule = {
  hydrationPriority: number;
  hydrateOn: HydrateOn;
};

const DEFAULT_SCHEDULE: HydrationSchedule = {
  hydrationPriority: 5,
  hydrateOn: 'idle',
};

const SCHEDULE_BY_NAME: Record<string, HydrationSchedule> = {
  Navigation: { hydrationPriority: 1, hydrateOn: 'idle' },
  SupplierListing: { hydrationPriority: 2, hydrateOn: 'idle' },
  Footer: { hydrationPriority: 3, hydrateOn: 'scroll' },
  MobileAppBanner: { hydrationPriority: 4, hydrateOn: 'idle' },
};

/**
 * Returns when and in what order a named SSR component should hydrate.
 * Unknown names wait behind the listing shell and start on idle.
 *
 * @param name - SSR component name (`Navigation`, `SupplierListing`, …).
 * @returns Priority (lower runs first) and the trigger that may enqueue it.
 */
export function hydrationScheduleFor(name: string): HydrationSchedule {
  return SCHEDULE_BY_NAME[name] ?? DEFAULT_SCHEDULE;
}
